import domReady from '../helpers/dom-ready';

class WC {
  static init(...parameters) {
    return new WC(...parameters);
  }

  constructor() {
    this.isCartPage = document.body.classList.contains('woocommerce-cart');

    this.setupCartUpdate();
    this.setupQuantityPurchase();

    jQuery('body').on('updated_cart_totals', () => {
      this.setupQuantityPurchase();
    });
    let timeout;

    jQuery(($) => {
      $('.woocommerce').on('change', 'input.qty', () => {
        if (timeout !== undefined) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
          $("[name='update_cart']").trigger('click');
        }, 1000);
      });
    });
  }

  setupCartUpdate() {
    jQuery('body').on('added_to_cart', () => {
      const cart = document.querySelector('.brix-menu .cart');

      cart.classList.add('-animate');

      setTimeout(() => {
        cart.classList.remove('-animate');
      }, 1500);
    });

    jQuery('body').on('adding_to_cart', (e, btn) => {
      if (window.innerWidth > 576) {
        const buttonText = btn[0].innerHTML;
        // eslint-disable-next-line no-param-reassign
        btn[0].innerHTML = btn[0].dataset.addedBtnLabel;

        setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
          btn[0].innerHTML = buttonText;
        }, 500);
      }
    });
  }

  setupQuantityPurchase() {
    this.updateCartButton = document.querySelector('.woocommerce-cart .woocommerce-cart-form button[name="update_cart"]');
    this.quantityInputs = document.querySelectorAll('input.qty');
    this.initialInputValues = [];

    [...this.quantityInputs].forEach((input, index) => {
      const product = input.parentElement.parentElement;
      const addButton = product.querySelector('.add_to_cart_button');
      const minusButton = product.querySelector('.minus');
      const plusButton = product.querySelector('.plus');

      this.initialInputValues.push(input.value);
      let timeout;

      minusButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (input.value > 0) {
          input.value = parseInt(input.value, 10) - 1; // eslint-disable-line no-param-reassign
          input.dispatchEvent(new Event('change'));
        }
        this.toggleDisabledUpdateButton(index);

        jQuery(($) => {
          if (timeout !== undefined) {
            clearTimeout(timeout);
          }

          timeout = setTimeout(() => {
            $("[name='update_cart']").trigger('click');
          }, 1000);
        });
      });

      plusButton.addEventListener('click', (e) => {
        e.preventDefault();
        input.value = parseInt(input.value, 10) + 1; // eslint-disable-line no-param-reassign
        input.dispatchEvent(new Event('change'));

        this.toggleDisabledUpdateButton(index);

        jQuery(($) => {
          if (timeout !== undefined) {
            clearTimeout(timeout);
          }

          timeout = setTimeout(() => {
            $("[name='update_cart']").trigger('click');
          }, 1000);
        });
      });

      if (addButton) {
        input.addEventListener('change', () => {
          addButton.dataset.quantity = input.value;
        });
      }
    });
  }

  toggleDisabledUpdateButton() {
    if (!this.isCartPage) {
      return;
    }

    let enableButton = false;

    [...this.quantityInputs].forEach((input, index) => {
      const valueHasChanged = input.value !== this.initialInputValues[index];
      if (!enableButton && valueHasChanged) {
        enableButton = true;
      }
    });

    if (enableButton) {
      this.updateCartButton.disabled = false;
      this.updateCartButton.setAttribute('aria-disabled', false);
    } else {
      this.updateCartButton.disabled = true;
      this.updateCartButton.setAttribute('aria-disabled', true);
    }
  }
}

domReady(() => {
  WC.init();
});
